<template>
  <div class="payment-alipay-container">
    <div class="payment-alipay-content">
      <div class="payment-alipay-header">
        <h2>支付宝支付设置</h2>
        <p>配置支付宝支付相关参数</p>
      </div>
      
      <!-- 帮助文档 -->
      <div class="help-document">
        <span class="help-title">帮助文档</span>
        <el-button type="text" @click="helpVisible = !helpVisible" style="float: right;">
          {{ helpVisible ? '收起' : '展开' }}
        </el-button>
      </div>
      <el-card class="help-card" shadow="hover" style="margin-bottom: 20px;">
        <div v-if="helpVisible" class="help-content">
          <h4>支付宝支付开通流程：</h4>
          <ol>
            <li>登录<a href="https://open.alipay.com/" target="_blank">支付宝开放平台</a></li>
            <li>注册并认证开发者账号</li>
            <li>在开放平台中创建应用</li>
            <li>获取应用ID</li>
            <li>生成应用私钥和公钥</li>
            <li>配置回调地址</li>
            <li>上线应用</li>
          </ol>
          <h4>参数说明：</h4>
          <ul>
            <li><strong>应用ID</strong>：在支付宝开放平台创建的应用的ID</li>
            <li><strong>应用私钥</strong>：通过支付宝开放平台的密钥生成工具生成的私钥</li>
            <li><strong>支付宝公钥</strong>：在支付宝开放平台中设置应用公钥后，支付宝返回的公钥</li>
            <li><strong>回调地址</strong>：支付结果通知的回调地址，必须是外网可访问的地址</li>
            <li><strong>支付成功页面</strong>：用户支付成功后跳转的页面地址</li>
            <li><strong>签名类型</strong>：推荐使用RSA2，安全性更高</li>
          </ul>
        </div>
      </el-card>
      
      <el-form :model="form" label-width="120px">
        <el-form-item label="启用支付宝">
          <el-switch v-model="form.enabled" active-text="启用" inactive-text="禁用"></el-switch>
        </el-form-item>
        
        <el-form-item label="应用ID">
          <el-input v-model="form.appId" placeholder="请输入支付宝应用ID"></el-input>
        </el-form-item>
        
        <el-form-item label="应用私钥">
          <el-input
            v-model="form.privateKey"
            type="textarea"
            :rows="4"
            placeholder="请输入应用私钥"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="支付宝公钥">
          <el-input
            v-model="form.alipayPublicKey"
            type="textarea"
            :rows="4"
            placeholder="请输入支付宝公钥"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="回调地址">
          <el-input v-model="form.notifyUrl" placeholder="请输入回调地址"></el-input>
        </el-form-item>
        
        <el-form-item label="支付成功页面">
          <el-input v-model="form.returnUrl" placeholder="请输入支付成功页面地址"></el-input>
        </el-form-item>
        
        <el-form-item label="签名类型">
          <el-select v-model="form.signType" placeholder="选择签名类型">
            <el-option label="RSA2" value="RSA2"></el-option>
            <el-option label="RSA" value="RSA"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PaymentAlipay',
  data() {
    return {
      form: {
        enabled: false,
        appId: '',
        privateKey: '',
        alipayPublicKey: '',
        notifyUrl: 'https://www.weixiaobuai.com/api/pay/alipay/notify',
        returnUrl: 'https://www.weixiaobuai.com/pay/success',
        signType: 'RSA2'
      },
      helpVisible: false
    }
  },
  mounted() {
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get('/admin/config/payment-alipay')
        if (response.data.code === 200) {
          this.form = response.data.data
        }
      } catch (error) {
        console.error('加载支付宝配置失败:', error)
      }
    },
    async saveSettings() {
      try {
        const response = await axios.put('/admin/config/payment-alipay', this.form)
        if (response.data.code === 200) {
          this.$message.success('设置保存成功')
        } else {
          this.$message.error('保存失败')
        }
      } catch (error) {
        console.error('保存支付宝配置失败:', error)
        this.$message.error('保存失败')
      }
    },
    resetForm() {
      this.loadSettings()
      this.$message.info('表单已重置')
    }
  }
}
</script>

<style scoped>
.payment-alipay-container {
  padding: 20px 0;
}

.payment-alipay-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.payment-alipay-header {
  margin-bottom: 30px;
}

.payment-alipay-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.payment-alipay-header p {
  font-size: 14px;
  color: #aaa;
  margin: 0;
}

.help-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.help-content {
  padding: 10px 0;
}

.help-content h4 {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.help-content ol, .help-content ul {
  margin-left: 20px;
  color: #333;
  line-height: 1.5;
}

.help-content strong {
  color: #333;
  font-weight: 600;
}

.help-content a {
  color: #409EFF;
  text-decoration: none;
  font-weight: 500;
}

.help-content a:hover {
  text-decoration: underline;
}

.help-title {
  color: #ff4d4f;
  font-weight: bold;
}

.help-document {
  margin-bottom: 10px;
  padding: 10px;
  background: rgba(255,255,255,0.05);
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.1);
}

.help-document::after {
  content: '';
  display: table;
  clear: both;
}
</style>
